import classNames from 'classnames';
import React from 'react';

type PersonalDataMaskProps = React.HTMLProps<HTMLSpanElement>;

const PersonalDataMask: React.FC<PersonalDataMaskProps> = ({ children, className, ...rest }) => {
  return (
    <span {...rest} className={classNames(className, 'ctHidden pii-data')}>
      {children}
    </span>
  );
};

export default PersonalDataMask;
